import React from 'react'
import {exportInventoryReportQRCode} from '../../app/util'
import {getArtworkCollection, getArtworkCollectionAdmin} from '../../api/artworkCollections'
import {getArtistNames} from '../../api/artistNames'
import moment from 'moment'
import HttpError from '../base/HttpError'
import {is_admin_user} from "../../app/role";
import {message} from 'antd'

export default (artistId, role, rawData, selectedItems, collectionFilter, usedTypeFilter) => {
    const artistIds = []
    if (selectedItems && selectedItems.length > 0) {
        selectedItems.forEach((item) => {
            if (item.artist) {
                if (artistIds.indexOf(item.artist) === -1)
                    artistIds.push(item.artist)
            }
        })
    } else {
        if (artistId) {
            artistIds.push(artistId)
        }else{
            rawData.forEach((item)=>{
                artistIds.push(item.artist)
            })
        }
    }
    if (artistIds.length === 0) {
        message.error('Need choose an artist first!').then(() => {})
        return
    }

    async function export_qrcode() {
        const request_func2 = is_admin_user({role: role}) ? getArtworkCollectionAdmin : getArtworkCollection
        let name_promises = []
        let collection_promises = []
        artistIds.forEach((_artistId) => {
            name_promises.push(getArtistNames(_artistId))
            collection_promises.push(request_func2(1, 1000000, artistId))
        })
        let artistNames = []
        let artistCollections = []

        let res1 = Promise.all(name_promises)
        let res2 = Promise.all(collection_promises)

        let results1 = await res1
        let results2 = await res2

        results1.forEach((res) => {
            artistNames = artistNames.concat(res.data)
        })

        results2.forEach((res) => {
            artistCollections = artistCollections.concat(res.data.results)
        })

        const date = moment().format('MM/DD/YYYY')

        let artworkData = selectedItems.length === 0
                ? rawData
                : rawData.filter((item) => {
                    const ret = selectedItems.filter((select) => {
                        return select.id.toString() === item.id.toString()
                    })
                    if (ret.length !== 0) {
                        return item
                    }
                })

        let artist_artworks = new Map()
        artworkData.forEach((data)=>{
            let artist = data.artist
            let data_array
            if (artist_artworks.has(artist)) {
                data_array = artist_artworks.get(artist)
            }else{
                artist_artworks.set(artist, [])
                data_array = artist_artworks.get(artist)
            }
            data_array.push(data)
            artist_artworks.set(artist, data_array)
        })
        let artworkArtistData = []
        artist_artworks.forEach((value, key, map)=>{
            artworkArtistData.push(value)
        })

        let promises = exportInventoryReportQRCode(
            artistNames,
            artistCollections,
            date,
            artworkArtistData,
            collectionFilter,
            usedTypeFilter
        )

        await promises
    }

    export_qrcode().then((res)=>{

    }).catch((e)=>{
        HttpError(e)
    })
}
